<template>
  <div class="column is-9">
    <div class="is-border is-radius-large has-bg-white content content-guide">
      <div class="column is-border-bottom is-paddingless-bottom">
        <h1>{{errortitle}}</h1>
      </div>
      <div class="contenterror" style="text-align: center;">
        <br>
        {{errorcontent}}
      </div>
      <div class="gif" style="text-align: center;">
        <img src="https://media.giphy.com/media/VwoJkTfZAUBSU/giphy.gif">
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
const contentful = require('contentful')

export default {
  name: 'MyError',
  data () {
    return {
      errortitle: null,
      errorcontent: null
    }
  },
  created () {
    this.getmessage()
  },
  computed: mapState(['contentfullClient']),
  methods: {
    getmessage () {
      const client = contentful.createClient({
        space: '1gymb3e2piir',
        accessToken: 'afd209d71174301d3271784f835a4b2583bf61cf6a3b9b2eba12ff61f0ef3c5d'
      })

      client.getEntries().then(response => {
        console.log(response.items)
        response.items.forEach(e => {
          if (e.sys.id === '7IW0yLStTqeG2u4W0UIAig') {
            this.errortitle = e.fields.titre
            this.errorcontent = e.fields.abstract
          }
        })
      }).catch(console.error)
    }
  }
}
</script>
